import React from 'react';
import { Card, Descriptions, Tag, Button, Collapse } from 'antd';
import { CopyOutlined, CodeOutlined } from '@ant-design/icons';
import type { Chunk } from '@/shared/api/types';

interface ChunkDetailPanelProps {
  chunk?: Chunk;
}

const ChunkDetailPanel: React.FC<ChunkDetailPanelProps> = ({ chunk }) => {
  if (!chunk) {
    return (
      <Card title="Chunk详情" size="small">
        <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
          请选择一个chunk查看详情
        </div>
      </Card>
    );
  }

  // 复制内容到剪贴板
  const handleCopyContent = () => {
    navigator.clipboard.writeText(chunk.chunk_content)
      .then(() => {
        // 可以添加通知，这里简单处理
      })
      .catch(err => {
        console.error('复制失败:', err);
      });
  };

  return (
    <Card
      title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <CodeOutlined />
            <span>Chunk详情</span>
          </div>
          <Button
            type="text"
            size="small"
            icon={<CopyOutlined />}
            onClick={handleCopyContent}
          >
            复制内容
          </Button>
        </div>
      }
      size="small"
    >
      <Descriptions column={1} size="small">
        <Descriptions.Item label="Chunk索引">
          <Tag color="blue">#{chunk.chunk_index + 1}</Tag>
        </Descriptions.Item>

        <Descriptions.Item label="内容大小">
          {chunk.chunk_size} 字符
        </Descriptions.Item>

        <Descriptions.Item label="向量状态">
          <Tag color={chunk.has_embedding ? 'green' : 'orange'}>
            {chunk.has_embedding ? '已向量化' : '未向量化'}
          </Tag>
        </Descriptions.Item>
      </Descriptions>

      <div style={{ marginTop: '16px' }}>
        <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
          内容:
        </div>
        <div
          style={{
            backgroundColor: '#f6f8fa',
            padding: '12px',
            borderRadius: '4px',
            fontSize: '13px',
            lineHeight: '1.5',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            maxHeight: '200px',
            overflowY: 'auto',
            fontFamily: 'monospace'
          }}
        >
          {chunk.chunk_content}
        </div>
      </div>

      {chunk.metadata && Object.keys(chunk.metadata).length > 0 && (
        <div style={{ marginTop: '16px' }}>
          <Collapse
            size="small"
            ghost
            items={[
              {
                key: 'metadata',
                label: '元数据',
                children: (
                  <div
                    style={{
                      backgroundColor: '#f6f8fa',
                      padding: '12px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      fontFamily: 'monospace',
                      maxHeight: '150px',
                      overflowY: 'auto'
                    }}
                  >
                    <pre style={{ margin: 0 }}>
                      {JSON.stringify(chunk.metadata, null, 2)}
                    </pre>
                  </div>
                )
              }
            ]}
          />
        </div>
      )}
    </Card>
  );
};

export default ChunkDetailPanel;